import React from 'react';
import { Route } from 'react-router';

import { ROUTES } from '../../../../core/router/routes';
import KeywordAdd from '../../KeywordAdd';
import KeywordEdit from '../../KeywordEdit';
import KeywordList from '../../KeywordList';

const KeywordRoute = () => [
  <Route path={ROUTES.KEYWORD.ADD} key={ROUTES.KEYWORD.ADD} component={KeywordAdd} />,
  <Route path={ROUTES.KEYWORD.EDIT} key={ROUTES.KEYWORD.EDIT} component={KeywordEdit} />,
  <Route path={ROUTES.KEYWORD.LIST} key={ROUTES.KEYWORD.LIST} component={KeywordList} />,
];

export default KeywordRoute;
